import { gql } from "@apollo/client";
import { APICall } from "../api_helper";

export const DELETE_REFERENCE_LIBRARY_ELEMENT = gql`
  mutation deleteReferenceLibraryElement(
    $id: Int
    $session: String!
    $eventMetadata: EventMetadata!
  ) {
    deleteReferenceLibraryElement(
      id: $id
      session: $session
      eventMetadata: $eventMetadata
    )
  }
`;

export const DELETE_LOCATION = gql`
  mutation deleteLocation($id: Int!) {
    deleteLocation(id: $id)
  }
`;

export const DELETE_PERSON = gql`
  mutation deletePerson($id: Int!) {
    deletePerson(id: $id)
  }
`;

export const CREATE_LOCATION = gql`
  mutation createLocation($session: String!, $name: String!) {
    createLocation(session: $session, name: $name) {
      name
      id
    }
  }
`;

export const CREATE_PEOPLE = gql`
  mutation createPerson(
    $session: String!
    $name: String!
    $organizationIds: [Int]
  ) {
    createPerson(
      session: $session
      name: $name
      organizationIds: $organizationIds
    ) {
      name
      id
      organizations {
        name
        id
      }
    }
  }
`;

export const CREATE_USER = {
  documentNode: gql`
    mutation createUser($email: String!, $password: String!) {
      createUser(email: $email, password: $password)
    }
  `,
  key: "createUser",
};

export const LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`;

export const CREATE_REFERENCE_LIBRARY_ELEMENT = gql`
  mutation createReferenceLibraryElement(
    $session: String!
    $name: String!
    $inputElementId: Int
    $body: String
    $type: Int!
    $physicalLibraryLocationId: Int
    $elementIds: [Int]
  ) {
    createReferenceLibraryElement(
      session: $session
      name: $name
      inputElementId: $inputElementId
      body: $body
      type: $type
      physicalLibraryLocationId: $physicalLibraryLocationId
      elementIds: $elementIds
    ) {
      name
      id
      body
      type
      physicalLibraryLocation {
        name
        id
      }
      elements {
        name
        id
        type
      }
    }
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation updateSettings($session: String!, $show_tooltips: Boolean!) {
    updateSettings(session: $session, show_tooltips: $show_tooltips)
  }
`;

export const UPDATE_REFERENCE_LIBRARY = gql`
  mutation updateReferenceLibrary(
    $session: String!
    $name: String!
    $id: Int!
    $body: String
    $type: Int!
    $physicalLibraryLocationId: Int
  ) {
    updateReferenceLibrary(
      session: $session
      name: $name
      id: $id
      body: $body
      type: $type
      physicalLibraryLocationId: $physicalLibraryLocationId
    ) {
      id
      name
      body
      type
      physicalLibraryLocation {
        name
        id
      }
    }
  }
`;

export const LOG_EVENT = gql`
  mutation logEvent(
    $session: String
    $event_session: String
    $event_type_id: Int!
    $event_metadata: String
    $version: VersionInput!
    $source: Int!
  ) {
    logEvent(
      session: $session
      event_session: $event_session
      event_type_id: $event_type_id
      event_metadata: $event_metadata
      version: $version
      source: $source
    )
  }
`;

export const CREATE_LIST = gql`
  mutation createList($session: String!, $name: String!, $listItems: [String]) {
    createList(session: $session, name: $name, listItems: $listItems) {
      name
      id
    }
  }
`;

export const SET_LIST_ITEM_VALUE = gql`
  mutation setListItemValue($session: String!, $id: Int!, $value: Boolean!) {
    setListItemValue(session: $session, id: $id, value: $value)
  }
`;
export const CREATE_PHYSICAL_LIBRARY_LOCATION = gql`
  mutation createPhysicalLibraryLocation($session: String!, $name: String!) {
    createPhysicalLibraryLocation(session: $session, name: $name) {
      name
      id
    }
  }
`;

export const UPDATE_PHYSICAL_LIBRARY_LOCATION = gql`
  mutation updatePhysicalLibraryLocation(
    $session: String!
    $name: String!
    $id: Int!
  ) {
    updatePhysicalLibraryLocation(session: $session, name: $name, id: $id) {
      name
      id
    }
  }
`;

export const DELETE_PHYSICAL_LIBRARY_LOCATION = gql`
  mutation deletePhysicalLibraryLocation(
    $session: String!
    $id: Int!
    $deletionStrategy: PhysicalLibraryLocationDeletionStrategy!
  ) {
    deletePhysicalLibraryLocation(
      session: $session
      id: $id
      deletionStrategy: $deletionStrategy
    )
  }
`;

export const SET_DEFAULT_PRIORITY = gql`
  mutation setDefaultPriority($session: String!, $default_priority: Int!) {
    setDefaultPriority(session: $session, default_priority: $default_priority)
  }
`;

export const NEW_UPDATE_ELEMENT: APICall = {
  documentNode: gql`
    mutation newUpdateElement(
      $session: String!
      $id: Int!
      $name: String!
      $type: Int!
      $eventMetadata: EventMetadata!
      $priority: Int!
      $lifeDomainId: Int
      $parentElementId: Int
      $topItemOfDay: Boolean
      $minuteEstimate: Int
      $blocksIds: [Int]
      $blockedByIds: [Int]
      $personId: Int
      $organizationId: Int
    ) {
      newUpdateElement(
        session: $session
        id: $id
        name: $name
        type: $type
        eventMetadata: $eventMetadata
        priority: $priority
        lifeDomainId: $lifeDomainId
        parentElementId: $parentElementId
        topItemOfDay: $topItemOfDay
        minuteEstimate: $minuteEstimate
        blocksIds: $blocksIds
        blockedByIds: $blockedByIds
        personId: $personId
        organizationId: $organizationId
      ) {
        id
        name
        type
        isChildElement
        priority
        topItemOfDay
      }
    }
  `,
  key: "newUpdateElement",
};

export const CREATE_NEW_ELEMENT: APICall = {
  documentNode: gql`
    mutation createNewElement(
      $session: String!
      $name: String!
      $type: Int!
      $eventMetadata: EventMetadata!
      $priority: Int!
      $lifeDomainId: Int
      $parentElementId: Int
      $topItemOfDay: Boolean
      $minuteEstimate: Int
      $personId: Int
      $organizationId: Int
      $blocksIds: [Int]
      $blockedByIds: [Int]
    ) {
      createNewElement(
        session: $session
        name: $name
        type: $type
        eventMetadata: $eventMetadata
        priority: $priority
        lifeDomainId: $lifeDomainId
        parentElementId: $parentElementId
        topItemOfDay: $topItemOfDay
        minuteEstimate: $minuteEstimate
        blocksIds: $blocksIds
        blockedByIds: $blockedByIds
        personId: $personId
        organizationId: $organizationId
      ) {
        id
        name
        type
        priority
        lifeDomain {
          id
          name
        }
        parentElement {
          id
          name
        }
        isChildElement
        childNextActions {
          id
          name
        }
        childSomedayMaybes {
          id
          name
        }
        childProjects {
          id
          name
        }
        childWaitingFors {
          id
          name
        }
      }
    }
  `,
  key: "createNewElement",
};

export const NEW_DELETE_ELEMENT: APICall = {
  documentNode: gql`
    mutation newDeleteElement(
      $id: Int!
      $session: String!
      $isChildElement: Boolean!
      $parentDeletionStrategy: ParentDeletionStrategy
      $eventMetadata: EventMetadata!
    ) {
      newDeleteElement(
        id: $id
        session: $session
        isChildElement: $isChildElement
        parentDeletionStrategy: $parentDeletionStrategy
        eventMetadata: $eventMetadata
      )
    }
  `,
  key: "newDeleteElement",
};

export const NEW_COMPLETE_ELEMENT: APICall = {
  documentNode: gql`
    mutation newCompleteElement(
      $id: Int!
      $session: String!
      $eventMetadata: EventMetadata!
      $isChildElement: Boolean!
      $parentCompletionStrategy: ParentCompletionStrategy
    ) {
      newCompleteElement(
        id: $id
        session: $session
        eventMetadata: $eventMetadata
        isChildElement: $isChildElement
        parentCompletionStrategy: $parentCompletionStrategy
      )
    }
  `,
  key: "newCompleteElement",
};

export const COMPLETE_ELEMENT = gql`
  mutation completeElement(
    $id: Int!
    $session: String!
    $eventMetadata: EventMetadata!
  ) {
    completeElement(id: $id, session: $session, eventMetadata: $eventMetadata)
  }
`;
